import { Dropdown } from 'primereact/dropdown';
import React, { useState, useEffect } from 'react';
import { store } from '../../../../../store/index.js';
import { getAttrValue } from '../../../../../api/propChecker.js';
import { v4 } from 'uuid';

const C2Select = (props) => {
    const { opts } = props;
    const [value, setValue] = useState("");
    const [options, setOptions] = useState([]);
    const id = v4();
    useEffect(() => {
        setValue(getAttrValue(opts.value, store.getState().variables));
        setOptions(getAttrValue(opts.options, store.getState().variables));
    }, [props]);
    const handleChange = (e) => {
        setValue(e.value);
        props.onChange({ [opts.valKey]: e.target.value });
    };
    return React.createElement("span", { className: "field" },
        React.createElement("label", { htmlFor: id }, opts.label),
        React.createElement(Dropdown, { id: id, className: "w-full", optionLabel: opts.labelKey || "name", options: options, value: value, onChange: (e) => { handleChange(e); } }));
};

export { C2Select as default };
//# sourceMappingURL=C2Select.js.map
